import moment from 'moment-timezone';

var zones = Object.keys(moment.tz._zones)
  .map(function(k) { return moment.tz._zones[k].split('|')[0]; })
  .filter(function(z) { return z.indexOf('/') >= 0; })
  .sort()
  .map(i => ({ label: i, value: i }))


const primaryZones = [
  { value: 'Pacific/Honolulu', label: 'Hawaii Time, Honolulu, HI' },
  { value: 'America/Anchorage', label: 'Alaska Time, Anchorage, AK' },
  { value: 'America/Los_Angeles', label: 'Pacific Time, Los Angeles, CA' },
  { value: 'America/Denver', label: 'Mountain Time, Denver, CO' },
  { value: 'America/Phoenix', label: 'Mountain Time, Phoenix, AZ' },
  { value: 'America/Chicago', label: 'Central Time, Chicago, IL' },
  { value: 'America/New_York', label: 'Eastern Time, New York, NY' },
  { value: 'America/Adak', label: 'Adak, AK' },
  { value: 'Canada/Atlantic', label: 'Atlantic Time' },
  { value: 'Canada/Newfoundland', label: 'Newfoundland' },
  { value: 'America/Buenos_Aires', label: 'Brazil, Buenos Aires, Georgetown' },
  { value: 'Pacific/Fiji', label: 'Enitwetok, Kwajalien' },
  { value: 'Pacific/Midway', label: 'Nome, Midway Island, Samoa' },
  {
    value: 'Pacific/Auckland',
    label: 'Auckland, Wellington, Fiji, Marshall Islands',
  },
  {
    value: 'Atlantic/Stanley',
    label: 'Mid-Atlantic, Ascention Island, St Helens',
  },
  { value: 'Atlantic/Azores', label: 'Azores, Cape Verde Islands' },
  {
    value: 'Europe/London',
    label: 'Casablanca, Dublin, Edinburgh, London, Lisbon',
  },
  { value: 'Europe/Berlin', label: 'Berlin, Brussels, Copenhagen, Madrid' },
  { value: 'Africa/Cairo', label: 'Kaliningrad, South Africa, Warsaw' },
  { value: 'Asia/Riyadh', label: 'Baghdad, Riyadh, Moscow, Nairobi' },
  { value: 'Asia/Tehran', label: 'Tehran' },
  { value: 'Asia/Tbilisi', label: 'Adu Dhabi, Baku, Muscat, Tbilisi' },
  { value: 'Asia/Kabul', label: 'Kabul' },
  { value: 'Asia/Karachi', label: 'Islamabad, Karachi, Tashkent' },
  { value: 'Asia/Kolkata', label: 'Bombay, Calcutta, Madras, New Delhi' },
  { value: 'Asia/Almaty', label: 'Almaty, Colomba, Dhaka' },
  { value: 'Asia/Bangkok', label: 'Bangkok, Hanoi, Jakarta' },
  {
    value: 'Asia/Hong_Kong',
    label: 'Beijing, Hong Kong, Perth, Singapore,...',
  },
  { value: 'Asia/Seoul', label: 'Osaka, Sapporo, Seoul, Tokyo, Yakutsk' },
  { value: 'Australia/Darwin', label: 'Adelaide, Darwin' },
  {
    value: 'Australia/Melbourne',
    label: 'Melbourne, Papua New Guinea, Sydney',
  },
  {
    value: 'Asia/Vladivostok',
    label: 'Magadan, New Caledonia, Solomon Islands',
  },
];

const secondaryZones = zones.filter(z => !primaryZones.find(x => x.value === z.value));

export default [
  ...primaryZones,
  ...secondaryZones
]

export const DEFAULT_ZONE = 'America/Los_Angeles';
